import Requestor from '@/api/Requestor';
import { clientInstance } from '@/api/core';
class FulfillmentApi extends Requestor {
    /**
     * 총판 수행상황 조회
     */
    getFulfillmentByDist(distId) {
        return this.get({
            url: `/api/v1/fulfillment/distributor/${distId}`,
            params: {},
        });
    }
    /**
     * 허브 수행상황 조회
     */
    getFulfillmentByHub(distId, hubId) {
        return this.get({
            url: `/api/v1/fulfillment/distributor/${distId}/hub/${hubId}`,
            params: {},
        });
    }
    /**
     * 라이더별 수행상황 조회
     * @param distId 총판 아이디
     * @param hubId 허브 아이디
     * @param workerCode 라이더 코드
     */
    getFulfillmentByWorker(distId, hubId, workerCode) {
        return this.get({
            url: `/api/v1/fulfillment/distributor/${distId}/hubs/${hubId}/workers/${workerCode}`,
            params: {},
        });
    }
    /**
     * 현재 수행 가능 라이더 조회
     * https://qc-zoo-client-api.barogo.io/docs/api-guide.html#_5_32_%EC%88%98%ED%96%89%EA%B0%80%EB%8A%A5_%EB%9D%BC%EC%9D%B4%EB%8D%94_%EC%A1%B0%ED%9A%8C
     * @param orderId 주문 아이디
     */
    getAllocatableWorker(orderId) {
        return this.get({
            url: `/api/v1/orders/${orderId}/allocatable-worker`,
        });
    }
}
export default new FulfillmentApi(clientInstance);
